// extracted by mini-css-extract-plugin
module.exports = {"Grid":"GiftCardList_Grid__3UiyQ","Row":"GiftCardList_Row__IKlR3","Column":"GiftCardList_Column__NxR3N"};